export class Result<T, E = unknown> {
    constructor(public isSuccess: boolean, public value?: T, public error?: E) {}

    // 성공 시 실행할 함수
    onSuccess(fn: (value: T) => void): Result<T, E> {
        if (this.isSuccess && this.value !== undefined) {
            fn(this.value);
        }
        return this;
    }

    onFailure(fn: (error: E) => void): Result<T, E> {
        if (!this.isSuccess && this.error !== undefined) {
            fn(this.error as E);
        }
        return this;
    }
}

export function runCatching<T>(fn: () => T): Result<T> {
    try {
        const result = fn();
        return new Result<T>(true, result);
    } catch (error) {
        return new Result<T>(false, undefined, error);
    }
}

export async function runCatchingAsync<T>(fn: () => Promise<T>): Promise<Result<T>> {
    try {
        const result = await fn();
        return new Result<T>(true, result);
    } catch (error: unknown) {
        if (error instanceof Error) {
            return new Result<T>(false, undefined, error);
        } else {
            return new Result<T>(false, undefined, new Error(String(error)));
        }
    }
}
